export default __webpack_public_path__ + "static/featured_image_og_codilime_glossary-8364ac7fb84da6c9a53b2a7b1cb77678.jpg";